import React from 'react'

function Magatron() {
  return (

    <>
    <h2>Megatron Container</h2>
    <code>megatron</code>
    <br/>
    <br/>
    <br/>
    <div className='megatron'>Megatron Container</div>
    <br/>
    <div className='megatron bg-apple'>Megatron Container</div>
    <br/>
    <div className='megatron bg-prime'>Megatron Container</div>
    </>

    )
}

export default Magatron